function PageHeader({ Brand }) {

    return (
        <div id="headerPage" className="container">
            <span id="brand" className='col-9 col-md-3'>
                <a href="/" >
                    {Brand.URL === "" ? <h1>{Brand.name}</h1>
                    : <img src={Brand.URL} alt={Brand.name} />}
                </a>
            </span>
        </div>
    );
}

export default PageHeader
